import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/node_modules/@mui/material/CircularProgress/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/_components/xnotice-content/xnotice-content.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/globals.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/banner.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/components/ClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/components/core/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/components/core/localized-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/components/core/xnotice-component.tsx");
